__turbopack_context__.v({
  "card": "AsideActionCard-module-scss-module__u4hDrG__card",
  "cta": "AsideActionCard-module-scss-module__u4hDrG__cta",
  "fade-in": "AsideActionCard-module-scss-module__u4hDrG__fade-in",
  "no-transform": "AsideActionCard-module-scss-module__u4hDrG__no-transform",
  "price": "AsideActionCard-module-scss-module__u4hDrG__price",
  "priceExclTax": "AsideActionCard-module-scss-module__u4hDrG__priceExclTax",
  "priceItem": "AsideActionCard-module-scss-module__u4hDrG__priceItem",
  "priceLabel": "AsideActionCard-module-scss-module__u4hDrG__priceLabel",
  "priceList": "AsideActionCard-module-scss-module__u4hDrG__priceList",
  "priceMeta": "AsideActionCard-module-scss-module__u4hDrG__priceMeta",
  "pricePrevious": "AsideActionCard-module-scss-module__u4hDrG__pricePrevious",
  "priceValue": "AsideActionCard-module-scss-module__u4hDrG__priceValue",
  "rotate": "AsideActionCard-module-scss-module__u4hDrG__rotate",
  "timestamp": "AsideActionCard-module-scss-module__u4hDrG__timestamp",
  "utilities": "AsideActionCard-module-scss-module__u4hDrG__utilities",
});
